module.exports = {"140802001":"中城街道","140802002":"东城街道","140802003":"西城街道","140802004":"南城街道","140802005":"北城街道","140802006":"安邑街道","140802007":"大渠街道","140802008":"姚孟街道","140802100":"解州镇","140802101":"龙居镇","140802102":"北相镇","140802103":"泓芝驿镇","140802104":"三路里镇","140802105":"陶村镇","140802106":"东郭镇","140802200":"席张乡","140802201":"金井乡","140802202":"王范乡","140802203":"冯村乡","140802204":"上郭乡","140802205":"上王乡","140802402":"山西运城经济开发区","140802403":"运城空港经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140802.json
// module id = 333
// module chunks = 0